import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option, StatusOption } from 'shared/types/general';
import { equipmentApi } from '../api/equipmentApi';

export const useEquipmentFormOptions = () => {
  const translationPrefix = 'entities.equipment';
  const { t } = useTranslation();

  const [statusOptions, setStatusOptions] = useState<StatusOption[]>([]);
  const [ivdrOptions, setIvdrOptions] = useState<StatusOption[]>([]);
  const [warehouses, setWarehouses] = useState<Option[]>([]);

  useEffect(() => {
    equipmentApi.getFormOptions().then(({ statusOptions, ivdrOptions, warehouses }) => {
      setStatusOptions(
        statusOptions.map((item) => ({
          ...item,
          display_name: t(`${translationPrefix}.status_options.${item.display_name}`)
        }))
      );
      setIvdrOptions(ivdrOptions);
      setWarehouses(warehouses);
    });
  }, [t]);

  return { statusOptions, ivdrOptions, warehouses };
};
